import { Decimal } from 'decimal.js-light'

import type { OrchestratedAuctionListingDetails } from '@b-stock/fe-core/bstock-next/queries'

export const getUserMinBidAmount = ({
  bidAmount = 0,
  bidCanceled,
  bidPrecision,
  nextMinBidAmount,
  startPrice,
  winningBidAmount,
}: {
  bidAmount?: number | null
  bidCanceled?: boolean | undefined
  bidPrecision: number
  nextMinBidAmount: number | null
  startPrice: number | null
  winningBidAmount: number | null
}) => {
  const currentPrice = Math.max(startPrice ?? 0, winningBidAmount ?? 0)
  const effectiveUserBid = bidCanceled ? 0 : (bidAmount ?? 0)
  const nextUserBidAmount = new Decimal(effectiveUserBid).plus(bidPrecision)

  return Math.max(
    currentPrice,
    nextMinBidAmount ?? 0,
    nextUserBidAmount.toNumber()
  )
}

export const getUserMinBidAmountForAuction = ({
  bid,
  bidPrecision = 1,
  nextMinBidAmount,
  startPrice,
  winningBidAmount,
}: OrchestratedAuctionListingDetails['auction']) =>
  getUserMinBidAmount({
    bidAmount: bid?.bidAmount,
    bidCanceled: bid?.canceled,
    bidPrecision,
    nextMinBidAmount,
    startPrice,
    winningBidAmount,
  })
